<template>
    <div class="sag-right-side-bar">
        <div class='rightsidenav-overlay' :class="'overlay-' + name"></div>
            
        <!-- 觸發按鈕 -->
        <b-row class="mb-1">
            <b-col cols="6">
                <slot name="toggle-button">

                </slot>
            </b-col>
        </b-row>
        
        <!-- right side bar -->
        <Transition :name="'side-bar-' + name">
            <div v-if="isToggle" class="right-side-bar">
                <!-- 關閉鈕 -->
                <b-row>
                    <b-col>
                        <div class="close" @click="toggle(false, false)">&times;</div>
                    </b-col>
                </b-row>
                <slot></slot>
                <b-row>
                    <!-- YES / NO -->
                    <sag-button
                        :label="'確定'"
                        :addClass="'text-right'"
                        @click="toggle(false, true)"
                        variant="success"
                    />
                    <sag-button 
                        :label="'取消'" 
                        :addClass="'text-left'"
                        @click="toggle(false, false)"
                        variant="danger"
                    />
                </b-row>
            </div>
        </Transition>
    </div>
</template>

<script>
import { 
    BRow,
    BCol,
    BButton
} from 'bootstrap-vue'
import SagButton from '@/components/basic/SagButton.vue'
import SagRightSideBarBase from './SagRightSideBarBase'
export default {
    components: {
        BButton,
        BRow,
        BCol,
        SagButton
    },
    props: {
        name: {
            type: String,
            required: true
        },
        serviceName: {
            type: String,
            required: true
        }
    },
    setup(props, { emit }) {
        const { isToggle, toggle } = SagRightSideBarBase(props, emit)

        return {
            isToggle,
            toggle
        }
    }
}
</script>

<style lang="scss">
@import '@/@core/scss/base/bootstrap-extended/variables.scss';
.sag-right-side-bar .rightsidenav-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 120vh;
  background-color: rgba($black, 0.5);
  z-index: 997;
  display: block;
  visibility: hidden;
  opacity: 0;
  transition: all 0.5s ease;
  &.show {
    opacity: 1;
    visibility: visible;
    transition: all 0.5s ease;
  }
}
</style>
